var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomPalette = function SvgCustomPalette(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#custom-palette_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3a9 9 0 0 1 8.838 10.71c-.336 1.741-2.034 2.512-3.516 2.335l-.158-.022-1.566-.261a1.161 1.161 0 0 0-1.011.324c-.333.333-.493.791-.269 1.238.381.762.386 1.631.05 2.343C13.918 20.622 12.999 21 12 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9Zm-4.05 8.1a1.349 1.349 0 1 0 0 2.698 1.349 1.349 0 0 0 0-2.698Zm6.3-3.6a1.35 1.35 0 1 0 0 2.7 1.35 1.35 0 0 0 0-2.7Zm-4.5 0a1.35 1.35 0 1 0 0 2.7 1.35 1.35 0 0 0 0-2.7Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "custom-palette_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgCustomPalette;